// extracted by mini-css-extract-plugin
export default {"offers":"Offers_offers__Cafy5","head":"Offers_head__lQTDN"};